import { ampli } from "~/ampli/index";

export default defineNuxtPlugin({
  name: "amplitude",
  parallel: true,
  async setup(app) {
    // Load amplitude
    await ampli.load({
      // Note Sven: commented out, since our settings only seem to have one environment anyway
      // environment: process.env.buildVariant === "prod" ? "production" : "development",
      environment: "production",
      client: {
        apiKey: "bc4c2153f9ae427650297510cd54c0e7",
        configuration: {
          defaultTracking: false,
          autocapture: {
            sessions: true,
            pageViews: true,
          },
          serverUrl: "https://collect.align.bi/2/httpapi",
        },
      },
    }).promise;

    // Provide amplitude to the app
    return { provide: { amplitude: ampli } };
  },
});
